/**
 * The error reducer to handle sharing errors between components
 * @param {Object} initialState The initial state of the quote.results object.
 * @returns {JSON} New state
 */
const createQuoteConfigReducer = (initialState = {}) => {
    return (state = initialState, action) => {
        switch (action.type) {
            case 'SET_CONFIG_VALUE': {
                // This is used to set various values that are required to work out logic in the form,
                // but which don't correspond to form inputs and don't need to be sent to the backend
                // eg postCodeSupportedGas, postCodeSupportedElec -
                return state.set(action.identifier, action.value);
            }
            case 'SET_CONFIG_VALUES': {
                // This is used to set various values that are required to work out logic in the form,
                // but which don't correspond to form inputs and don't need to be sent to the backend
                // eg postCodeSupportedGas, postCodeSupportedElec -
                // @todo: Add bill info should be included here, instead of it's own case.
                // made generic

                let newState = state;
                for (const configValue of action.values) {
                    newState = newState.set(configValue.identifier, configValue.value);
                }
                return newState;
            }

            default: {
                return state;
            }
        }
    };
};

export { createQuoteConfigReducer };
